import * as React from "react";
import { forwardRef } from "react";
const SvgClear = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.2008 7.80078L7.80078 16.2008M16.2008 16.2008L7.80078 7.80078L16.2008 16.2008Z", stroke: "#A4A5AA", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClear);
export { ForwardRef as ReactComponent };
